<script setup lang="ts">
import {useSeoStore} from "~/stores/useSeoStore";
import {watchDebounced} from "@vueuse/shared";
import {useLocaleStore} from "~/stores/useLocaleStore";

const { newTranslations, postTranslationBatchHandler, setUiConfigTranslates } = useLocaleStore();
const { locale: localeI18n } = useI18n();
const { keyWords } = useSeoStore();
const config = useRuntimeConfig();

useHead({
  htmlAttrs: {
    lang: localeI18n.value
  },
  script: [
    {
      innerHTML: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${config.public.gtmId}');`,
      type: 'text/javascript'
    },
  ],
  noscript: [
    {
      children: `<iframe src="https://www.googletagmanager.com/ns.html?id=${config.public.gtmId}"
        height="0" width="0" style="display:none;visibility:hidden"></iframe>`
    }
  ],
  meta: [
    { name: 'keywords', content: keyWords.value },
    { name: 'scroll-restoration', content: 'manual' }
  ]
});

watch(localeI18n, (newLocale) => {
  useHead({
    htmlAttrs: {
      lang: newLocale,
      'data-capo': '',
    },
  });
});

onMounted(() => {
  setUiConfigTranslates();
})

watchDebounced(newTranslations, () => {
  postTranslationBatchHandler();
}, { debounce: 1000, maxWait: 2000, deep: true });

onMounted(() => {
  nextTick(() => {
    const script = document.createElement('script');
    script.src = '//cdn5.helpdeskeddy.com/js/modules/chat_widget/hde.js';
    script.defer = true;
    script.id = 'hde-chat-widget';
    script.setAttribute('data-lang', 'en');
    script.setAttribute('data-host', 'www.supportcrew.me');
    script.setAttribute('data-position', 'bottom-right');
    script.setAttribute('data-comment', 'SX');
    script.setAttribute('data-custom-button', 'hde-button');

    document.head.appendChild(script);

    setTimeout(() => {
      document.body.style.overflowY = ''
      document.documentElement.style.overflowY = ''
    })
  })
});
</script>

<template>
  <nuxt-layout>
    <nuxt-page />
  </nuxt-layout>
</template>

<style>
.ui-modal, .ui-drawer  {
  font-family: sans-serif;
}
.page-enter-active,
.page-leave-active {
  transition: all 0.4s;
}
.page-enter-from,
.page-leave-to {
  opacity: 0;
  filter: blur(1rem);
}
</style>
